import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const tiktokVideos = [
  {
    id: 1,
    thumbnail: 'https://public.readdy.ai/ai/img_res/650c44f98f8dcfdf9888efee363c946a.jpg',
    views: '284K',
    likes: '31K',
    caption: 'Zo gebruik je Evil Energy Destroy Zeep 🔥',
    duration: '0:47',
  },
  {
    id: 2,
    thumbnail: 'https://readdy.ai/api/search-image?query=blue%20protect%20balls%20indigo%20blue%20spheres%20dissolving%20in%20water%20mystical%20spiritual%20bath%20ritual%20dark%20elegant%20background%20blue%20glow%20water%20ripples%20vertical%20portrait%20format%20close%20up&width=400&height=700&seq=tiktok2&orientation=portrait',
    views: '512K',
    likes: '67K',
    caption: 'Blue Protect bad ritueel stap voor stap 💙',
    duration: '1:02',
  },
  {
    id: 3,
    thumbnail: 'https://readdy.ai/api/search-image?query=hing%20asafoetida%20burning%20incense%20smoke%20rising%20dark%20background%20mystical%20spiritual%20cleansing%20ritual%20smoke%20photography%20atmospheric%20moody%20ancient%20protection%20ritual%20vertical%20portrait%20format&width=400&height=700&seq=tiktok3&orientation=portrait',
    views: '1.2M',
    likes: '143K',
    caption: 'Waarom hing branden na bezoek? 🌿',
    duration: '0:58',
  },
  {
    id: 4,
    thumbnail: 'https://readdy.ai/api/search-image?query=spiritual%20woman%20performing%20ritual%20with%20candles%20crystals%20dark%20moody%20atmospheric%20mystical%20protection%20ceremony%20dark%20background%20warm%20candlelight%20glow%20vertical%20portrait%20format%20cinematic&width=400&height=700&seq=tiktok4&orientation=portrait',
    views: '389K',
    likes: '44K',
    caption: 'Mijn dagelijkse beschermingsritueel ✨',
    duration: '1:15',
  },
  {
    id: 5,
    thumbnail: 'https://readdy.ai/api/search-image?query=evil%20energy%20destroy%20kit%20unboxing%20dark%20background%20abalone%20shell%20white%20candle%20herbs%20incense%20ritual%20kit%20complete%20set%20dark%20stone%20surface%20warm%20dramatic%20lighting%20vertical%20portrait%20format&width=400&height=700&seq=tiktok5&orientation=portrait',
    views: '756K',
    likes: '89K',
    caption: 'Unboxing de Evil Energy Destroy Kit 📦',
    duration: '0:52',
  },
  {
    id: 6,
    thumbnail: 'https://readdy.ai/api/search-image?query=spiritual%20protection%20aura%20cleansing%20ritual%20dark%20mystical%20atmosphere%20woman%20meditating%20candles%20crystals%20dark%20background%20warm%20golden%20light%20vertical%20portrait%20format%20cinematic%20atmospheric&width=400&height=700&seq=tiktok6&orientation=portrait',
    views: '921K',
    likes: '112K',
    caption: 'Hoe weet je of je negatieve energie hebt? 🔮',
    duration: '1:28',
  },
];

export const TikTokSection = () => {
  const { t } = useTranslation();
  const [hoveredVideo, setHoveredVideo] = useState<number | null>(null);

  const stats = [
    { value: '87K', label: t('home_tiktok_followers'), icon: 'ri-user-heart-line' },
    { value: '3.2M', label: t('home_tiktok_likes'), icon: 'ri-heart-3-line' },
    { value: '12M', label: t('home_tiktok_views'), icon: 'ri-eye-line' },
  ];

  return (
    <section className="py-24 bg-[#050010] overflow-hidden relative">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gradient-to-r from-[#69C9D0]/8 via-[#EE1D52]/6 to-[#69C9D0]/8 rounded-full blur-3xl" />
      </div>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 relative z-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 mb-14">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2.5 px-4 py-2 bg-gradient-to-r from-[#EE1D52]/15 to-[#69C9D0]/15 border border-[#EE1D52]/25 rounded-full mb-5">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-tiktok-line text-[#EE1D52] text-sm" />
              </div>
              <span className="text-[#EE1D52] text-xs font-bold uppercase tracking-widest">@zpiritualz.com</span>
            </div>

            <h2 className="text-3xl lg:text-5xl font-black text-white mb-4 leading-tight">
              {t('home_tiktok_title')}{' '}
              <span className="relative inline-block">
                <span className="text-transparent bg-gradient-to-r from-[#EE1D52] via-white to-[#69C9D0] bg-clip-text">
                  {t('home_tiktok_title2')}
                </span>
              </span>
            </h2>
            <p className="text-white/45 text-sm leading-relaxed">
              {t('home_tiktok_sub')}{' '}
              <strong className="text-white/70">87.000+ {t('home_tiktok_followers')}</strong>{' '}
              {t('home_tiktok_sub2')}
            </p>
          </div>

          {/* Stats */}
          <div className="flex gap-6 lg:gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-2xl bg-gradient-to-br from-[#EE1D52]/20 to-[#69C9D0]/20 border border-white/10">
                  <i className={`${stat.icon} text-white/70 text-base`} />
                </div>
                <p className="text-white font-black text-xl leading-none mb-1">{stat.value}</p>
                <p className="text-white/35 text-xs">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Video grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-12">
          {tiktokVideos.map((video) => (
            <a
              key={video.id}
              href="https://www.tiktok.com/@zpiritualz.com?is_from_webapp=1&sender_device=pc"
              target="_blank"
              rel="nofollow noreferrer"
              className="relative rounded-2xl overflow-hidden cursor-pointer group block"
              style={{ aspectRatio: '9/16' }}
              onMouseEnter={() => setHoveredVideo(video.id)}
              onMouseLeave={() => setHoveredVideo(null)}
            >
              <img
                src={video.thumbnail}
                alt={video.caption}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
                hoveredVideo === video.id ? 'opacity-100' : 'opacity-0'
              }`}>
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/15 backdrop-blur-sm border border-white/25">
                  <i className="ri-play-fill text-white text-2xl ml-1" />
                </div>
              </div>
              <div className="absolute top-2.5 right-2.5">
                <span className="px-2 py-0.5 bg-black/50 backdrop-blur-sm text-white/80 text-[10px] font-semibold rounded-md">
                  {video.duration}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <p className="text-white text-[11px] font-medium leading-tight line-clamp-2 mb-2">
                  {video.caption}
                </p>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-heart-fill text-[#EE1D52] text-[10px]" />
                    </div>
                    <span className="text-white/60 text-[10px] font-medium">{video.likes}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line text-white/50 text-[10px]" />
                    </div>
                    <span className="text-white/60 text-[10px] font-medium">{video.views}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-3xl overflow-hidden border border-white/10">
          <div className="absolute inset-0 bg-gradient-to-r from-[#EE1D52]/12 via-[#050010] to-[#69C9D0]/12" />
          <div className="absolute inset-0 bg-[#050010]/60" />

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 p-8 lg:p-10">
            <div className="flex items-center gap-6">
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-[#EE1D52]/25 to-[#69C9D0]/25 border border-white/15 shrink-0">
                <i className="ri-tiktok-line text-white text-3xl" />
              </div>
              <div>
                <h3 className="text-white font-black text-xl mb-1">{t('home_tiktok_no_miss')}</h3>
                <p className="text-white/45 text-sm leading-relaxed max-w-md">
                  {t('home_tiktok_no_miss_sub')}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="https://www.tiktok.com/@zpiritualz.com?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center justify-center gap-2.5 px-7 py-3.5 bg-gradient-to-r from-[#EE1D52] to-[#EE1D52]/80 text-white font-bold text-sm rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-tiktok-line text-sm" />
                </div>
                {t('home_tiktok_follow')}
              </a>
              <a
                href="https://www.tiktok.com/@zpiritualz.com?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center justify-center gap-2.5 px-7 py-3.5 bg-white/8 border border-white/15 text-white/70 font-medium text-sm rounded-full hover:bg-white/12 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-notification-3-line text-sm" />
                </div>
                {t('home_tiktok_notify')}
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
